export function setCursorToEnd(contentEditableElement: Node) {
    let range = document.createRange(); // Create a range
    let sel = window.getSelection(); // Get the selection object
    range.selectNodeContents(contentEditableElement); // Select the entire contents of the element
    range.collapse(false); // Collapse the range to the end
    sel.removeAllRanges(); // Remove any selections that might exist
    sel.addRange(range); // Add the new range
}

